import React from 'react';
import arrayMutators from 'final-form-arrays';
import { useIntl } from 'react-intl';

import { useSelector } from 'hooks';
import PageBaseProps from 'types/PageBase';
import FormKeys from 'modules/form/types/FormKeys';
import { FormValidatorWithIntl } from 'types/Form';
import { getStepsConfig } from 'modules/selfServices/stepsConfigSelectors';
import { KioskPreferencesForm } from 'types/QuestionsForm';
import { getSelectedSelfService } from 'modules/selfServices/selectors';
import { KioskPreferencesQuestionsIds } from 'modules/selfServices/constants';
import { isKioskPreferenceQuestionVisible } from 'modules/selfServices/utils';

import ConnectedForm from '../ui/ConnectedForm';
import KioskUsageRender from './KioskUsageRender';
import PopupErrorForm from '../Errors/PopupErrorForm';
import { setIn } from 'final-form';
import { questionResponseProperty } from '../../types/Question';

const validateForm: FormValidatorWithIntl<KioskPreferencesForm> = (intl, selfService, config) => ({ kioskPreferencesQuestions = [] }) => kioskPreferencesQuestions.reduce((acc, question, index) => {
  const isVisible = isKioskPreferenceQuestionVisible(
    question.id as KioskPreferencesQuestionsIds,
    selfService.type,
    selfService.origin,
    config,
  );
  if (isVisible && question.mandatory && typeof question[questionResponseProperty[question.type]] === 'undefined') {
    return setIn(
      acc,
      `kioskPreferencesQuestions[${index}].${questionResponseProperty[question.type]}`,
      intl.formatMessage({ id: 'validation.required', defaultMessage: 'Please answer to continue.' }));
  }
  return acc;

}, {});

const KioskUsageForm: React.FC<PageBaseProps> = ({ onNext, ...pageProps }) => {
  const intl = useIntl();
  const config = useSelector(getStepsConfig);
  const selfService = useSelector(getSelectedSelfService);

  return (
    <ConnectedForm
      onSubmit={onNext}
      component={KioskUsageRender}
      formKey={FormKeys.KIOSK_USAGE}
      mutators={{ ...arrayMutators }}
      subscription={{ hasValidationErrors: true }}
      validate={validateForm(intl, selfService, config)}
      {...pageProps}
      errorComponent={<PopupErrorForm errorMessage={{
        id: 'questions.mandatoryModal.title',
        defaultMessage: 'You must first answer {count, plural, one {the question} other {all questions}} marked with "{mandatory}".',
      }} />}
    />
  );
};

export default KioskUsageForm;
